import { useFormikContext, FormikContextType } from 'formik'
import { ChangeEvent } from 'react'

import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { CarbonCalculatorValues } from '../types'

export const PlantingMixFormFields = () => {
  const { setFieldValue }: FormikContextType<CarbonCalculatorValues> =
    useFormikContext()

  return (
    <>
      <FormField
        id='trees'
        formFieldClassName='bg-white'
        type={FormFieldTypes.number}
        label='Trees (%)'
        max={100}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const value = Number(e.target.value)
          const valueToSet = value > 100 ? 100 : value

          setFieldValue('trees', valueToSet)
          setFieldValue('shrubs', 100 - valueToSet)
        }}
      />
      <FormField
        id='shrubs'
        type={FormFieldTypes.number}
        label='Shrubs (%)'
        disabled
      />
    </>
  )
}
